import type { GetRowIdParams } from 'ag-grid-community';
import { BlotterGridDispatchProps, BlotterGridStateProps } from 'components/shared/Blotter/Grid/blotter.model';
import { useAppSelector } from 'hooks/useAppSelector';
import { selectTradesBlottersPageItems } from 'state/blotters/trades/tradesBlotters.selector';
import { TradesBlottersItemByBlotterType } from 'state/blotters/trades/types/blotterItem';
import { ClientSideBlotterType, MasterDetailsBlotterType } from 'state/blotters/trades/types/types';

import { useCommonConnect } from './useCommonConnect';

type OwnProps<T extends ClientSideBlotterType> = {
  blotter: T;
  parentId: T extends MasterDetailsBlotterType ? string : undefined;
  idKey: keyof TradesBlottersItemByBlotterType<T>;
  hasSidePanel?: boolean;
};
type StateProps<T extends ClientSideBlotterType> = BlotterGridStateProps<TradesBlottersItemByBlotterType<T>> & {
  getRowId: (p: GetRowIdParams) => string;
};
type DispatchProps<T extends ClientSideBlotterType> = BlotterGridDispatchProps<TradesBlottersItemByBlotterType<T>>;
type ClientSideConnectProps<T extends ClientSideBlotterType> = OwnProps<T> & StateProps<T> & DispatchProps<T>;

export function useClientSideConnect<T extends ClientSideBlotterType>(
  ownProps: OwnProps<T>,
): ClientSideConnectProps<T> {
  const commonProps = useCommonConnect(ownProps);
  const items = useAppSelector(state => selectTradesBlottersPageItems(state, ownProps.blotter, ownProps.parentId));

  return {
    ...ownProps,
    ...commonProps,
    items,
  };
}
